// extracted by mini-css-extract-plugin
export var disabled = "_h-a";
export var hierarchyLinkGray = "_h-4";
export var hierarchyLinkUnderline = "_h-3";
export var hierarchyPrimary = "_h-0";
export var hierarchySecondary = "_h-1";
export var hierarchyTertiary = "_h-2";
export var pressed = "_h-6";
export var themeAction = "_h-5";
export var themeDestructive = "_h-8";
export var themeNormal = "_h-7";
export var themeSuccess = "_h-9";